import Typography from '@mui/material/Typography';
//import { cancerstat, cancerstat_3 } from "../../../../../constants";

export default function MicroInfoMicroText() {
  
  return (
<div>
    
<Typography variant="subtitle1">
Metagenomics Illumina shotgun sequencing of a stool sample is a powerful and affordable technique 
used to comprehensively profile the microbial community (bacteria, archaea, viruses, fungi, etc.) present in your gut.
<br /><br />
<Typography component="span" sx={{fontWeight: 600}}>What Is Shotgun Metagenomic Sequencing?</Typography>
<br /><br />
Shotgun metagenomics involves sequencing all genetic material present in a sample. 
Unlike 16S rRNA sequencing (which targets a specific gene in bacteria), 
shotgun sequencing captures the full diversity of microbes—including functional genes and non-bacterial organisms.
<br /><br />
<Typography component="span" sx={{fontWeight: 600}}>Sample Type: Stool</Typography>
<br /><br />
Stool samples are used because they are rich in gut microbes and are non-invasive to collect. They provide insights into:
<ul>
Gut microbiome composition<br />
Potential pathogens<br />
Functional potential of the microbial community (e.g., genes involved in metabolism, resistance, virulence)
</ul>
<br />
<Typography component="span" sx={{fontWeight: 600}}>Illumina Platform: Why It's Used</Typography>
<br /><br />
Illumina sequencing is preferred for shotgun metagenomics due to:
<ul>
High-throughput: Millions of reads per run<br />

High accuracy: Low error rate<br />

Short reads (typically 150–300 bp): Good for assembling microbial genomes and identifying genes
</ul>
<br />
<Typography component="span" sx={{fontWeight: 600}}>General Workflow</Typography>
<br /><br />
Sample Collection and Storage - DNA Extraction - Library Preparation - <br />Adapter ligation - PCR amplification (minimal to reduce bias) - Illumina Sequencing - 
<br />Bioinformatics Analysis - Quality control

</Typography>    
</div>

   )
}